module.exports = __webpack_public_path__ + "img/home3.57436878.png";